var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 10 7","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1 0.844849L5 4.84485L9 0.844849","stroke-width":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }